import { restRequest } from 'common-src/features/rest/actions';
import { HttpMethods } from 'common-src/features/rest/constants';

export const getPatientGuideCmsAlignmentsRequest = (query, params) =>
  restRequest({
    uri: 'patientGuideCmsAlignments',
    query,
    method: HttpMethods.Get,
    ...params,
  });

export const addPatientGuideCmsAlignment = (body, params) =>
  restRequest({
    uri: 'patientGuideCmsAlignments',
    method: HttpMethods.Post,
    body,
    ...params,
  });

export const updatePatientGuideCmsAlignmentTier = (body, params) =>
  restRequest({
    uri: 'patientGuideCmsAlignments/updateTier',
    method: HttpMethods.Put,
    body,
    ...params,
  });
